import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import commonEn from "./en/common.json";
import commonFr from "./fr/common.json";
import csEn from "./en/cs.json";
import csFr from "./fr/cs.json";
import validationEn from "./en/validation.json";
import validationFr from "./fr/validation.json";

const resources = {
  en: {
    common: commonEn,
    cs: csEn,
    validation: validationEn,
  },
  fr: {
    common: commonFr,
    cs: csFr,
    validation: validationFr,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en",
  defaultNS: "common",
  fallbackLng: "en",
  compatibilityJSON: "v3",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
